import React from 'react';
import { FaCamera } from 'react-icons/fa';
import {
    AspectRatio, Badge,
    Button, ButtonGroup,
    Card, CardActions,
    CardContent,
    CardOverflow,
    ChipDelete,
    Divider,
    IconButton,
    Typography
} from "@mui/joy";
import {MdAutoDelete, MdDelete, MdOutlineAutoDelete, MdRemoveDone} from "react-icons/md";
import {FiDelete} from "react-icons/fi";
import {AiFillDelete, AiOutlineDelete, AiTwotoneDelete} from "react-icons/ai";
import {LuDelete} from "react-icons/lu";
import {CgPlayListRemove, CgRemove} from "react-icons/cg";
import {CiCircleRemove, CiSquareRemove} from "react-icons/ci";
import {ImBoxRemove} from "react-icons/im";
import {IoIosRemoveCircleOutline, IoMdRemove} from "react-icons/io";
import {RiDeleteBin6Line} from "react-icons/ri"; // Using Font Awesome for the camera icon

const getPreferredResolution = (prefs) => {
    if (!prefs || !prefs.video) return "No video prefs available";

    const { h264 = [], h265 = [] } = prefs.video;

    let preferred, codec;
    if (h264.length > 0) {
        preferred = h264[0];
        codec = "H264";
    } else if (h265.length > 0) {
        preferred = h265[0];
        codec = "H265";
    } else {
        return "No codec info";
    }

    if (preferred.width || preferred.height || preferred.fps) {
        const width = preferred.width || "--";
        const height = preferred.height || "--";
        const fps = preferred.fps || "--";
        return `${codec}: ${width}x${height} @ ${fps}fps`;
    } else {
        return `${codec}: No resolution info`;
    }
};

const getDeviceImage = (device) => {
   if (device.type === "onvif") {
        if (device.onvif_settings) {
            var model = device.onvif_settings["model_name"]
            if (model == "DH-C5A") {
                return "https://dahua-technology.com.ua/image/cache/catalog/dahua/dahua-dh-c5a_2-800x800.jpg"
            } else if (model == "IPC-K2E-3H1W") {
                return "https://images.cdn-files-a.com/uploads/5140355/800_62155047c98ff.png"
            }
        }
    } else {
        return "https://www.seeedstudio.com/blog/wp-content/uploads/2024/08/03-1-1030x772.jpg"
    }
}

const DeviceCard = ({ device, onRemove }) => {
    const {id, name, type, prefs, is_live} = device;

    // Get preferred resolution and FPS
    const preferredResolution = getPreferredResolution(prefs);

    return (
        <Card sx={{width: 320}}>
            <div>
                <Badge color={is_live ? 'success' : 'danger'}>
                    <Typography level="title-lg">{name}</Typography>
                </Badge>
                <Typography level="body-sm">{type} : {id}</Typography>
                <IconButton
                    aria-label="Delete device"
                    variant="outlined"
                    color="neutral"
                    size="sm"
                    sx={{position: 'absolute', top: '1rem', right: '1rem'}}
                    onClick={() => onRemove(device)} // Call the onRemove function passed from parent
                >
                    <RiDeleteBin6Line/>
                </IconButton>
            </div>
            <AspectRatio minHeight="120px" maxHeight="200px">
                <img
                    src={getDeviceImage(device)}
                    srcSet={getDeviceImage(device)}
                    loading="lazy"
                    alt=""
                />
            </AspectRatio>
            <CardContent orientation="horizontal">
                <div>
                    <Typography level="body-xs">Video:</Typography>
                    <Typography sx={{fontSize: 'l', fontWeight: 'l'}}>{preferredResolution}</Typography>
                </div>
            </CardContent>

            <CardOverflow sx={{ bgcolor: 'background.level1' }}>
                <CardActions buttonFlex="1">
                    <ButtonGroup variant="outlined" sx={{ bgcolor: 'background.surface' }}>
                        <Button>Live</Button>
                        <Button>History</Button>
                        <Button>Settings</Button>
                    </ButtonGroup>
                </CardActions>
            </CardOverflow>
        </Card>
    );
}


export default DeviceCard;
